import {reportNonBizData} from "./mNonBizReport";

// 模板通用埋点 - 广告展示时的埋点上报
export const presetBtShow = {
    // 埋点上报
    value: function () {
        return {reportType: 'btShow', dataCustomized: {}}
    },
    action: reportNonBizData
}
// 模板通用埋点 - 广告被用户点击时的埋点上报
export const presetBtClick = {
    // 埋点上报
    value: function () {
        return {reportType: 'btClick', dataCustomized: {}}
    },
    action: reportNonBizData
}
// 模板通用埋点 - 广告被用户关闭时的埋点上报
export const presetBtClose = {
    // 埋点上报
    value: function () {
        return {reportType: 'btClose', dataCustomized: {}}
    },
    action: reportNonBizData
}
// 模板通用埋点 - 广告 showfailed 上报
export const presetBtAdShowFailed = {
    // 埋点上报
    value: function () {
        return {reportType: 'btAdShowFailed', dataCustomized: {}}
    },
    action: reportNonBizData
}
// 模板通用埋点 - 视频模板关闭需要跳转 endcard，但 endcard 还未加载完成时的埋点上报
export const presetBtEndcardShowFailed = {
    // 埋点上报
    value: function () {
        return {reportType: 'btEndcardShowFailed', dataCustomized: {}}
    },
    action: reportNonBizData
}
// 模板通用埋点 - webview 因为内存占用等问题导致 webview 被系统 kill 回收时进行的埋点上报
export const presetBtWebviewTerminate = {
    // 埋点上报
    value: function () {
        return {reportType: 'btWebviewTerminate', dataCustomized: {}}
    },
    action: reportNonBizData
}
// 模板通用埋点 - 通过 VideoBridge/init 获取到的 sdk_info 为 '' 时进行的埋点上报
export const presetBtInitSDKVersionEmpty = {
    // 埋点上报
    value: function () {
        return {reportType: 'btInitSDKVersionEmpty', dataCustomized: {}}
    },
    action: reportNonBizData
}

/**
 * 先播后选相关 preset
 */
export const presetBtPlayFirstShow = {
    // 埋点上报
    value: function () {
        return {reportType: 'btPlayFirstShow', dataCustomized: {}}
    },
    action: reportNonBizData
}

export const presetBtPlayFirstClick = {
    // 埋点上报
    value: function () {
        return {reportType: 'btPlayFirstClick', dataCustomized: {}}
    },
    action: reportNonBizData
}

export const presetBtPlayFirstDialogShow = {
    // 埋点上报
    value: function () {
        return {reportType: 'btPlayFirstDialogShow', dataCustomized: {}}
    },
    action: reportNonBizData
}

export const presetBtPlayFirstDialogClick = {
    // 埋点上报
    value: function () {
        return {reportType: 'btPlayFirstDialogClick', dataCustomized: {}}
    },
    action: reportNonBizData
}

export const presetBtPlayFirstDialogCloseManual = {
    // 埋点上报
    value: function () {
        return {reportType: 'btPlayFirstDialogCloseManual', dataCustomized: {}}
    },
    action: reportNonBizData
}

export const presetBtPlayFirstDialogCloseAuto = {
    // 埋点上报
    value: function () {
        return {reportType: 'btPlayFirstDialogCloseAuto', dataCustomized: {}}
    },
    action: reportNonBizData
}

export const presetBtPlayFirstClose = {
    // 埋点上报
    value: function () {
        return {reportType: 'btPlayFirstClose', dataCustomized: {}}
    },
    action: reportNonBizData
}

export const presetBtPlayFirstAdShowFailed = {
    // 埋点上报
    value: function () {
        return {reportType: 'btPlayFirstAdShowFailed', dataCustomized: {}}
    },
    action: reportNonBizData
}

export const presetBtPlayFirstEndcardShowFailed = {
    // 埋点上报
    value: function () {
        return {reportType: 'btPlayFirstEndcardShowFailed', dataCustomized: {}}
    },
    action: reportNonBizData
}

export const presetBtPlayFirstWebviewTerminate = {
    // 埋点上报
    value: function () {
        return {reportType: 'btPlayFirstWebviewTerminate', dataCustomized: {}}
    },
    action: reportNonBizData
}

export const presetBtPlayFirstInitSDKVersionEmpty = {
    // 埋点上报
    value: function () {
        return {reportType: 'btPlayFirstInitSDKVersionEmpty', dataCustomized: {}}
    },
    action: reportNonBizData
}

/**
 * RewardPlus 模板相关 preset
 */
// RewardPlus 大模板 - RP 弹窗被用户点击展开时的埋点上报
export const presetBtRPDialogExpand = {
    // 埋点上报
    value: function () {
        return {reportType: 'btRPDialogExpand', dataCustomized: {}}
    },
    action: reportNonBizData
}
// RewardPlus 大模板 - RP 弹窗在展开状态被用户点击跳转 offer2 时的埋点上报
export const presetBtRPDialogClick = {
    // 埋点上报
    value: function () {
        return {reportType: 'btRPDialogClick', dataCustomized: {}}
    },
    action: reportNonBizData
}
// RewardPlus 大模板 - RP 弹窗被用户点击收缩时的埋点上报
export const presetBtRPDialogCollapse = {
    // 埋点上报
    value: function () {
        return {reportType: 'btRPDialogCollapse', dataCustomized: {}}
    },
    action: reportNonBizData
}
// RewardPlus 大模板 - RP 弹窗因 offer2 模板加载失败而自动关闭时的埋点上报
export const presetBtRPDialogFailedClose = {
    // 埋点上报
    value: function () {
        return {reportType: 'btRPDialogFailedClose', dataCustomized: {}}
    },
    action: reportNonBizData
}

/**
 * Google Play 模板相关上报
 */
// GP页面加载成功
export const presetBtGpShowSuccess = {
    // 埋点上报
    value: function () {
        return {reportType: 'btGpShowSuccess', dataCustomized: {}}
    },
    action: reportNonBizData
}
// GP页面加载失败
export const presetBtGpShowFailed = {
    // 埋点上报
    value: function () {
        return {reportType: 'btGpShowFailed', dataCustomized: {}}
    },
    action: reportNonBizData
}